import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { Article } from '../../../interface';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { addQueuePromoCount } from '../../../store/emarsys/action';
import { dateFormatterEmarsysReverseMonthDate } from '../../../helpers/utils/dateFormatter';

const useImpressionPromo = (
  firstRef: React.RefObject<HTMLElement>,
  promo: Article,
  breadcrumbItems: IBreadcrumbs[],
  sectionName: string = '',
  optionalData?: {
    page_category?: string;
  }
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isPromoActive = getFlagValue(FLAG_ENUM.EMARSYS_PROMO);
      if (isAuth && isFlagActive && isPromoActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: 'promo detail page',
          page_title: promo?.titlePage || '',
          page_url: window.location.href,
          ...(breadcrumbItems?.[1]?.name && {
            menu_cat_lvl1: breadcrumbItems[1].name.toLowerCase(),
          }),
          ...(breadcrumbItems?.[2]?.name && {
            menu_cat_lvl2: breadcrumbItems[2].name.toLowerCase(),
          }),
          ...(breadcrumbItems?.[3]?.name && {
            menu_cat_lvl3: breadcrumbItems[3].name.toLowerCase(),
          }),
          section_name: sectionName,
          ...(optionalData?.page_category && { page_category: optionalData.page_category }),
        };

        if (promo?.startDate && promo?.endDate) {
          valuePageView.promo_periode = `${dateFormatterEmarsysReverseMonthDate(promo.startDate)} - ${dateFormatterEmarsysReverseMonthDate(promo.endDate)}`;
        }

        if (promo?.model?.[0]) {
          valuePageView.car_model_1 = promo?.model?.[0];
        }
        if (promo?.model?.[1]) {
          valuePageView.car_model_2 = promo?.model?.[1];
        }
        if (promo?.model?.[2]) {
          valuePageView.car_model_3 = promo?.model?.[2];
        }

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueuePromoCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionPromo;
